import { render, staticRenderFns } from "./LinkOrganizationPartners.vue?vue&type=template&id=48dcf939&scoped=true"
import script from "./LinkOrganizationPartners.vue?vue&type=script&lang=js"
export * from "./LinkOrganizationPartners.vue?vue&type=script&lang=js"
import style0 from "./LinkOrganizationPartners.vue?vue&type=style&index=0&id=48dcf939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dcf939",
  null
  
)

export default component.exports